<template>
  <v-row class="mt-1" v-for="(address, index) in updated_addresses" :key="index">
    <v-col cols="2">
      <v-text-field
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          v-model="address.number"
          hide-details
          flat>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('number') }}</span>
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="10">
      <v-text-field
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          v-model="address.formatted_address"
          hide-details
          flat>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('address') }}</span>
        </template>
        <template #append-inner>
          <v-icon @click="deleteAddress(address)" color="error" icon="mdi-trash-can"/>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
  <v-row class="mt-1">
    <v-col>
      <v-text-field
          density="default"
          class="reg-normal text-primary"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          :disabled="isDisabled"
          v-model="searchInput"
          hide-details
          flat
          clearable
          ref="autocomplete"
          id="inputSearch">
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('type_address') }}</span>
        </template>
        <template #append-inner>
          <v-icon color="primary" icon="mdi-map-marker"/>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import helpFunctions from "../../plugins/helpFunctions";

export default {
  props: ["modelValue", "is_submit", "isDisabled"],
  data() {
    return {
      updated_addresses: [],
      searchInput: '',
    };
  },
  mounted() {
    this.updated_addresses = this.modelValue ? this.modelValue : [];
    this.$nextTick(this.initGooglePlacesAutocomplete);
  },
  methods: {
    initGooglePlacesAutocomplete() {
      const loader = new Loader({
        apiKey: "AIzaSyDETzSbmipza8r7Ux2aqq5jNYwt7gndx_4",
        libraries: ["places"],
      });
      loader.load().then(() => {
        const inputElement = this.$refs.autocomplete?.$el.querySelector('input');
        const autocomplete = new google.maps.places.Autocomplete(inputElement, {
          types: ['address'],
          componentRestrictions: { country: "nl" },
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (!place.geometry) return;
          this.handlePlaceSelect(place);
        });
      });
    },
    handlePlaceSelect(place) {
      const address = {
        street: this.getAddressComponent(place.address_components, 'route'),
        zipcode: this.getAddressComponent(place.address_components, 'postal_code'),
        number: this.getAddressComponent(place.address_components, 'street_number'),
        city: this.getAddressComponent(place.address_components, 'locality'),
        municipality: this.getAddressComponent(place.address_components, 'administrative_area_level_2'),
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        country: 'NL',
        formatted_address: place.formatted_address,
        name: place.formatted_address,
        type: "visit",
      };
      if (!this.updated_addresses.find((addr) => addr.formatted_address === address.formatted_address)) {
        this.updated_addresses.push(address);
        this.searchInput = '';
        this.$emit('update', this.updated_addresses);
      }
    },
    async deleteAddress(row) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          this.updated_addresses = this.updated_addresses.filter((address) => address.id !== row.id || address.formatted_address !== row.formatted_address);
          if (row.id) {
            await helpFunctions.deleteModel(this.$toast, "addresses", row.id);
            this.$emit('update', this.updated_addresses);

          }
        }
      });
    },
    getAddressComponent(components, type) {
      return components.find(component => component.types.includes(type))?.long_name || '';
    },
  },
  watch: {
    modelValue: {
      handler() {
        this.updated_addresses = this.modelValue ? this.modelValue : [];
      },
    },
    is_submit:function() {
      this.searchInput = '';
    }
  },
}
</script>

<style>
/*GOOGLE DROPDOWN WITH ADDRESSES*/
.pac-container {
  z-index: 2500 !important;
}
</style>